<template>
    <div>
        <!-- PC导航 -->
        <div class="pc"  @mouseleave="close" :class="state == 1?'black':''">
            <div class="head2">
                <div class="logo" @click="url('/')">
                    <img :src="config.logo">
                </div>
                <div class="nav">
                    <div class="nav-item">
                        <li v-for="(item,index) in data" :key="index" @click="open(item)" @mouseover="mouse(item)">
                            <a class="item" href="javascript:;">
                                {{item.item_name}}
                            </a>
                        </li>
                    </div>
                </div>
                <div class="button">
                    <div class="search" @click="url('/search')">
                        <i class="el-icon-search"></i>
                    </div>
                    <div class="shop" @click="url('https://shop110158641.taobao.com/')">
                        <i class="el-icon-shopping-bag-2"></i>商城
                    </div>
                </div>
            </div>

            <div :class="state==0?'child':'child2'" v-if="child.length" >
                <div class="child-content">
                    <div class="child-item" v-for="(item,index) in child" :key="index" @click="url(item.item_url)">
                        <div class="child-image">
                            <img :src="item.item_image" style="height: 100px;">
                        </div>
                        <div class="child-name">{{item.item_name}}</div>
                    </div>
                </div>
            </div>
        </div>

        <el-backtop></el-backtop>
    </div>
</template>

<script>
    import {
        common_nav,
        common_config
    } from '@/api/common.js';
    export default {
        name: 'commonHead',
        props: {
            active: 0,
            state: 0,
        },

        data() {
            return {
                config: {},
                data: [],
                keyword: '',
                child:[],
            }
        },
        mounted() {
            this.keyword = this.$route.query.keyword;
        },
        created() {
            this.get_data();
            this.get_config();
        },
        methods: {
            get_data() {
                common_nav({
                    alias: 'index_nav'
                }).then(res => {
                    if (res.code == 200) {
                        this.data = res.data;
                    }
                });
            },
            get_config() {
                common_config({}).then(res => {
                    if (res.code == 200) {
                        this.config = res.data;
                    }
                });
            },
            url(path) {
                if(path == '0'){
                    return false;
                }
                window.location.href = path;
            },

            mouse(record){
                if(record.child.length){
                    this.child = record.child;
                }else{  
                    this.child = [];
                }
            },
            open(record){
                if(record.child.length){
                    this.child = record.child;
                }else{  
                    this.child = [];
                    this.url(record.item_url);
                }
            },
            close(){
                this.child = [];
            },
            //搜索
            search(e) {
                var keyword = e.target.value;
                if (this.$route.path == '/search') {
                    this.$emit('search', keyword);
                } else {
                    this.$router.push('/search?keyword=' + keyword);
                }
            },


        }
    }
</script>
<style lang="less" scoped>
    .child{
        position: relative;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
        z-index: 9999;
        width: 100%;
        min-width: 1300px;
        min-height: 200px;
    }
    .child2{
        position: absolute;
        top: 124px;
        left: 0;
        background: rgba(0,0,0,.7);
        z-index: 9999;
        width: 100%;
        min-width: 1300px;
        min-height: 200px;
    }
    .child-content{
        width: 1300px;
        margin: 0 auto;
        padding: 20px 20px;
    }
    .child-item{
        display: inline-block;
        margin-right: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        margin-bottom: 20px;
    }
    .child-image{
        height: 100px;
    }

    .head2 {
        height: 124px;
        width: 100%;
        min-width: 1300px;
        position: relative;
    }

    .logo {
        width: 250px;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        line-height: 100px;
        cursor: pointer;
    }

    .logo img {
        height: 50px;
        margin-left: 50px;
        margin-top: 44px;
    }

    .button {
        float: right;
        margin-right: 100px;
        cursor: pointer;
    }

    .search {
        display: inline-block;
        width: 50px;
        color: #fff;
        font-size: 20px;
        margin-top: 55px;
        cursor: pointer;
    }

    .shop {
        display: inline-block;
        color: #fff;
        background: red;
        width: 83px;
        height: 25px;
        border-radius: 22px;
        text-align: center;
        line-height: 25px;
        margin-top: 55px;
        cursor: pointer;
    }

    .nav-item {
        float: left;
    }

    .nav {
        height: 124px;
        min-width: 500px;
        width: auto;
        text-align: center;
        position: absolute;
        left: 250px;
        top: 0;
        overflow: hidden;
    }

    .black {
        color: #333;
        background: #fff;
    }

    .nav ul {
        padding: 0;
        margin: 0;
    }

    .nav li {
        list-style: none;
        display: inline-block;
        padding-bottom: 20px ;
        height: 100px;
    }

    .black .active {
        color: #333 !important;
        border-radius: 20px;
    }

    .black .item {
        color: #333;
    }

    .black .item:hover {
        color: #333;
    }

    .item {
        color: #fff;
        font-size: 16px;
        text-decoration: none;
        display: inline-block;
        margin-top: 54px;
        margin-right: 50px;
        font-weight: 500;
    }

    .active {
        color: #9c9c9c;
        border-bottom: 1px solid #9C9C9C;
    }

    .item:hover {
        color: #9C9C9C;
        border-bottom: 1px solid #9C9C9C;
    }
    .black{
        color: #333;
    }
    .black .button{
        color: #333;
    }
    .black .search{
        color: #333;
    }
</style>